export const FETCH_EXPENSE_ACTION = "FETCH_EXPENSE_ACTION";
export const FETCH_EXPENSE_FAIL_ACTION = FETCH_EXPENSE_ACTION + "_ERROR";
export const FETCH_EXPENSE_SUCCESS_ACTION = FETCH_EXPENSE_ACTION + "_SUCCESS";

export const APPROVE_EXPENSE_ACTION = "APPROVE_EXPENSE_ACTION";
export const APPROVE_EXPENSE_FAIL_ACTION = APPROVE_EXPENSE_ACTION + "_ERROR";
export const APPROVE_EXPENSE_SUCCESS_ACTION =
  APPROVE_EXPENSE_ACTION + "_SUCCESS";

export const REJECT_EXPENSE_ACTION = "REJECT_EXPENSE_ACTION";
export const REJECT_EXPENSE_FAIL_ACTION = REJECT_EXPENSE_ACTION + "_ERROR";
export const REJECT_EXPENSE_SUCCESS_ACTION = REJECT_EXPENSE_ACTION + "_SUCCESS";

export const FETCH_EXPENSE_HEAD_IN_EXPENSE_ACTION =
  "FETCH_EXPENSE_HEAD_IN_EXPENSE_ACTION";
export const FETCH_EXPENSE_HEAD_IN_EXPENSE_FAIL_ACTION =
  FETCH_EXPENSE_HEAD_IN_EXPENSE_ACTION + "_ERROR";
export const FETCH_EXPENSE_HEAD_IN_EXPENSE_SUCCESS_ACTION =
  FETCH_EXPENSE_HEAD_IN_EXPENSE_ACTION + "_SUCCESS";
